var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.17927 15.0834L0.237267 8.22438C0.219267 8.20638 0.202268 8.18772 0.186268 8.16838L0.176268 8.15638L0.167267 8.14538L0.159268 8.13538V8.12938L0.152268 8.11938V8.11238L0.146267 8.10338L0.141268 8.09538V8.08838L0.135267 8.07838V8.07238L0.100267 8.05038L0.0922662 8.03539C0.0105197 7.88027 -0.0180015 7.70259 0.0110875 7.52968C0.0401765 7.35677 0.125266 7.19821 0.253267 7.07838L7.17927 0.235382C7.33264 0.084534 7.53914 0 7.75427 0C7.96939 0 8.1759 0.084534 8.32927 0.235382C8.4044 0.30977 8.46404 0.398316 8.50475 0.495895C8.54545 0.593475 8.56641 0.698154 8.56641 0.803883C8.56641 0.909612 8.54545 1.01429 8.50475 1.11187C8.46404 1.20945 8.4044 1.298 8.32927 1.37238L2.77627 6.85038H17.5203C17.7334 6.85038 17.9377 6.93504 18.0884 7.08572C18.2391 7.23641 18.3238 7.44078 18.3238 7.65388C18.3238 7.86699 18.2391 8.07136 18.0884 8.22205C17.9377 8.37273 17.7334 8.45738 17.5203 8.45738H2.77627L8.33027 13.9504C8.4054 14.0248 8.46504 14.1133 8.50575 14.2109C8.54645 14.3085 8.56741 14.4132 8.56741 14.5189C8.56741 14.6246 8.54645 14.7293 8.50575 14.8269C8.46504 14.9245 8.4054 15.013 8.33027 15.0874C8.17677 15.238 7.97031 15.3224 7.75527 15.3224C7.54022 15.3224 7.33376 15.238 7.18027 15.0874L7.17927 15.0834Z",
    fill: "#003EBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/Left Arrow.de6203f7.svg";
export { ForwardRef as ReactComponent };